export const MyName = "Muhammad Hammad Aslam";
